@if(paymentInfo){
<div nz-row [nzGutter]="[0,8]">
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'accountType']">
    <div nz-row nzAlign="middle">
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Account Type
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.accountType ? paymentInfo?.accountType : '-' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'bankOrMoneyAppName']">
    <div nz-row nzAlign="middle">
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Bank Or Money App Name
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.bankOrMoneyAppName ? paymentInfo?.bankOrMoneyAppName : '-' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'routingNumber']">
    <div nz-row nzAlign="middle">
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Routing Number
      </div>
      <div nz-col nzSpan="6" [nzXs]="6" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.routingNumber ? paymentInfo?.routingNumber : '-'}}
      </div>
      @if(canUnmaskBankDetails && paymentInfo?.routingNumber.startsWith('X'))
        {
          <div nz-col style="margin-left:4px">
            <ppl-button ariaLabel="UnMask" label="UnMask" icon="fa fa-eye" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="unmaskIdentifier('ROUTING')">
            </ppl-button>
          </div>
        }
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'accountNumber']">
    <div nz-row nzAlign="middle">
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Account Number
      </div>
      <div nz-col nzSpan="12" [nzXs]="6" ngClass="pt-2  mobile-value-left-paddiing">
        {{ paymentInfo?.accountNumber ? paymentInfo?.accountNumber : '-' }}
      </div>
      @if(canUnmaskBankDetails && paymentInfo?.accountNumber.startsWith('X'))
        {
          <div nz-col style="margin-left:4px">
            <ppl-button ariaLabel="UnMask" label="UnMask" icon="fa fa-eye" [customClass]="'ghost-button'"
                  [iconPosition]="'left'" (click)="unmaskIdentifier('ACCOUNT')">
            </ppl-button>
          </div>
        }
    </div>
  </div>
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'optedOutOfPaperPaystubs']">
    <div nz-row nzAlign="middle">

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2 font-weight-600">
        Electronic Paystubs
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2 mobile-value-left-paddiing">
        {{ paymentInfo?.optedOutOfPaperPaystubs ? "Yes" : 'No' }}
      </div>
    </div>
  </div>

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'paperCheck']">
    <div nz-row nzAlign="middle">
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="pt-2 font-weight-600">
        Paper Paychecks
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2 mobile-value-left-paddiing">
        {{ paymentInfo?.paperCheck ? "Yes" : 'No' }}
      </div>
    </div>
  </div>
</div>
}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}